import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('home', {
            abstract: true,
            url: '/',
            templateUrl: 'views/common/home.html',
            controller: 'homeController',
          })
          .state('home.homeToken', {
            url: 'home?t',
            templateUrl: 'views/common/home.html',
            controller: 'homeController',
          })
          .state('home.list', {
            url: '',
            templateUrl: '/views/documents/list.html',
            controller: 'documentsController',
          })
          .state('home.folder', {
            url: 'folder/:id/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'documentsController',
          })
          .state('home.digitalizations', {
            url: 'digitalizations/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'digitalizationsController',
          })
          .state('home.favorites', {
            url: 'favorites/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'favoritesController',
          })
          .state('home.checkouts', {
            url: 'checkouts/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'checkoutsController',
          })
          .state('home.shareds', {
            url: 'shareds/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'sharedsController',
          })
          .state('home.trashcan', {
            url: 'trashcan/:page',
            templateUrl: '/views/documents/list.html',
            controller: 'trashCanController',
            data: {
              permissions: {
                only: ['ADMIN', 'ManageTrashCan'],
                redirectTo: 'home.list',
              },
            },
          })
          .state('home.myDeadLines', {
            url: 'myDeadLines/:page',
            templateUrl: '/views/documents/myDeadLines.html',
            controller: 'myDeadLinesController',
          })
          .state('home.search', {
            url: 'search?q&p&f&l&e',
            templateUrl: '/views/documents/list.html',
            controller: 'documentsSearchController',
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
